import { createContext, useContext } from 'react'

import { QueueProcessModel } from '@models/queueProcess'

type QueueMenuContextProps = {
  queueProcess?: QueueProcessModel
  refetchQueueProcess: () => void
}

const QueueMenuContext = createContext<QueueMenuContextProps>({
  queueProcess: undefined,
  refetchQueueProcess: () => {},
})

const useQueueMenu = () => useContext(QueueMenuContext)

export { QueueMenuContext, useQueueMenu }
